import axiosClient from "../common/axios_client";

class Api {
  showCompanies(name) {
    return axiosClient.get(`/api/v1/companies/autocomplete?term=${name}`).then(response => {
      return response.data;
    });
  }

  postStartup(data) {
    const options = {
      responseType: "json",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return axiosClient.post("/api/v1/registrations/startups", data, options).then(response => {
      return response.data;
    });
  }

  postTwitterCallback(data) {
    const options = {
      responseType: "json",
      headers: {
        "Content-Type": "application/json"
      }
    };
    return axiosClient.post("/api/v1/oauth/twitter/callback", data, options).then(response => {
      return response.data;
    });
  }

  deleteTwitterLink() {
    const options = {
      responseType: "json",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return axiosClient.delete("/api/v1/oauth", {
      data: { provider: "twitter" }
    }, options).then(response => {
      return response.data;
    });
  }
}

export default Api;
